import { WidgetsConfigList } from 'common/widgetsConfig';
import EmbedCode from 'components/EmbedCode/EmbedCode';
import ButtonsSection from 'components/SettingsWidget/ButtonsSection';
import SettingsWidget from 'components/SettingsWidget/SettingsWidget';
import { getFormattedWidth } from 'components/utils';
import { useSettingsWidgetHandler } from 'hooks/useSettingsWidgetHandler';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';
import BaseMetalsChartsWidget from 'widgets/BaseMetalsChartsWidget';

function BaseMetalsChartsPage() {
    const { width } = useWindowSize();
    const embedCodeConfig = WidgetsConfigList.baseMetalsCharts;
    const {
      isContainerChecked,
      isTransparentChecked,
      widthValue,
      theme,
      handleChange,
      handleContainerChecked,
      handleThemeChange,
      handleTrasparentChecked,
      handleResetSettings,
      isReset,
      formattedConfig,
      setSelectedMetal,
      selectedMetal,
      selectedTimeFrame, 
      setSelectedTimeFrame, 
      handleApply,
      handleBlur, 
      config
    } = useSettingsWidgetHandler({ 
      widgetId: embedCodeConfig.container_id,
      widthDefault: width < 500 ? 300 : 400, 
      defaultMetal: embedCodeConfig.defaultMetal, 
      defaultTimeFrame: embedCodeConfig.defaultTimeFrame 
    });
    const listMetals: DefaultBMMetals[] = ['CU', 'NI', 'AL', 'ZN', 'PB', 'UR'];
    const listTimeFrames: DefaultTimeFrame[] = ['24H', '30D', '60D', '6M', '1Y', '5Y'];

  return (
    <div className='pt-[20px] pb-[40px] w-full flex flex-col items-center'>
      <div className='text-[30px] mulish-600 text-silver pb-4'>Base Metals Charts</div>
      <div className='w-full lg:w-1/2 flex flex-col items-center'>
    
      <BaseMetalsChartsWidget config={config}/>

       <SettingsWidget
          widthValue={widthValue}
          theme={theme}
          handleBlur={() => handleBlur(300)}
          isTransparentChecked={isTransparentChecked}
          isContainerChecked={isContainerChecked}
          handleChange={handleChange}
          isReset={isReset}
          selectedMetal={selectedMetal}
          setSelectedMetal={setSelectedMetal}
          setSelectedTimeFrame={setSelectedTimeFrame}
          selectTimeFrame={selectedTimeFrame}
          listTimeFrames={listTimeFrames}
          listMetals={listMetals}
          handleContainerChecked={handleContainerChecked}
          handleThemeChange={handleThemeChange}
          defaultWidth='300'
          handleTrasparentChecked={handleTrasparentChecked}
        /> 

       <ButtonsSection
          isTransparentChecked={isTransparentChecked}
          widthValue={widthValue}
          theme={theme}
          formattedConfig={formattedConfig}
          handleApply={handleApply}
          embedCodeConfig={embedCodeConfig}
          handleResetSettings={handleResetSettings}
        />

        <EmbedCode
          width={getFormattedWidth(config.useContainerSize, widthValue)}
          isTransparent={isTransparentChecked}
          colorTheme={theme}
          formattedConfig={formattedConfig}
          embedCodeConfig={embedCodeConfig}
        />

      </div>
    </div>
  );
}

export default BaseMetalsChartsPage;